import { useLazyGetPreviewUrlQuery } from "store/apis/previewUrl";
import { BackendError } from "types/utils/error";
import { useToast } from "hooks/useToast";
import { openLink } from "utils/openLink";

export const useDownloadFile = () => {
  const [getPreviewUrl, result] = useLazyGetPreviewUrlQuery();
  const { alertToast } = useToast();

  const downloadFile = async ({
    file_id,
    group_id,
  }: {
    file_id: string;
    group_id: string;
  }) => {
    try {
      const { download_url } = await getPreviewUrl({
        groupId: group_id,
        fileId: file_id,
      }).unwrap();
      openLink(download_url, "_blank");
    } catch (error) {
      alertToast(
        {
          message: (error as BackendError)?.data?.error?.message,
        },
        error as Error
      );
    }
  };

  return { downloadFile, result };
};
